import { createLightTheme, BrandVariants } from "@fluentui/react-components";

const agrelloBrand: BrandVariants = {
  10: "#050317",
  20: "#1a1454",
  30: "#2b1f7a",
  40: "#3a2b96",
  50: "#4636b0",
  60: "#4f46e5",
  70: "#635ae8",
  80: "#776eeb",
  90: "#8b83ee",
  100: "#9f98f1",
  110: "#b3adf4",
  120: "#c7c3f7",
  130: "#dbd8fa",
  140: "#efedfc",
  150: "#f7f6fe",
  160: "#fcfcff",
};

export const agrelloTheme = createLightTheme(agrelloBrand);
